import React from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import _Button from "../generic/_Button";

const _ModalDanger = (props) => {
  const { visible, title, onClose, onAction, description, isLoading } = props;

  const _onClose = () => {
    if (onClose) onClose();
  };

  const _onAction = () => {
    if (onAction) onAction();
  };

  return (
    <Modal show={visible} onHide={_onClose} centered backdrop={true}>
      <Modal.Header closeButton>
        <div className="text-xl font-semibold text-gray-600">{title}</div>
      </Modal.Header>
      <Modal.Body>
        <p>{description}</p>
      </Modal.Body>
      <Modal.Footer>
        <div className="flex gap-2 items-center justify-start">
          <_Button
            title="Aceptar"
            style="danger"
            onClick={_onAction}
            isLoading={isLoading}
            disabled={visible && isLoading}
          />

          <_Button
            title="Cancelar"
            style="none"
            onClick={_onClose}
            isLoading={isLoading}
            disabled={visible && isLoading}
          />
        </div>
      </Modal.Footer>
    </Modal>
  );
};

_ModalDanger.propTypes = {
  visible: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
  onClose: PropTypes.func,
  onAction: PropTypes.func,
  isLoading: PropTypes.bool,
};

export default _ModalDanger;
